var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRect = function SvgRect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M24.4429 25.4994H7.55661C7.27664 25.4994 7.00812 25.3882 6.81015 25.1902C6.61218 24.9923 6.50098 24.7238 6.50098 24.4438V7.55624C6.50098 7.27627 6.61218 7.00777 6.81015 6.8098C7.00812 6.61184 7.27664 6.50061 7.55661 6.50061H24.4441C24.5828 6.50045 24.7201 6.52765 24.8483 6.58064C24.9764 6.63363 25.0929 6.71137 25.191 6.80943C25.289 6.90748 25.3668 7.02393 25.4198 7.15208C25.4728 7.28023 25.4999 7.41757 25.4998 7.55624V24.4438C25.4999 24.5826 25.4727 24.72 25.4196 24.8482C25.3666 24.9765 25.2887 25.0929 25.1905 25.191C25.0923 25.2891 24.9758 25.3668 24.8475 25.4197C24.7192 25.4727 24.5817 25.4997 24.4429 25.4994ZM8.61103 23.3882H23.3885V8.61185H8.61103V23.3882Z"
  })));
};
export default SvgRect;